import type { TranslationDictionary } from "./types";

export const ZH_TW_DICTIONARY: TranslationDictionary = {
    "app.newTask": "新增",
    "app.newTaskAria": "新建對話",
    "sidebar.searchPlaceholder": "搜尋提示詞或任務ID",
    "sidebar.filters": "任務篩選",
    "sidebar.allRatios": "全部比例",
    "sidebar.allOrientations": "全部方向",
    "sidebar.allModes": "全部模式",
    "sidebar.allResolutions": "全部解析度",
    "sidebar.allStatuses": "全部狀態",
    "sidebar.activeTasks": "活動任務",
    "sidebar.topAnchors": "頂部時間導航",
    "sidebar.bottomAnchors": "底部時間導航",
    "sidebar.resize": "調整側欄寬度",
    "batch.selected": "已選擇 0 個",
    "batch.selectedCount": "已選擇{count}個",
    "batch.selectCurrentGroup": "全選本組",
    "batch.archivedCount": "已歸檔{count}個會話",
    "batch.archiveFailed": "批次歸檔失敗",
    "batch.runningCannotDeleteSelected": "選取的會話正在執行，且無法刪除",
    "batch.deleteTitle": "刪除{count}個會話？",
    "batch.deleteMessage": "會同時刪除本機圖片檔案。",
    "batch.deleteSkippedDetail": "{count}個運行中任務會保留",
    "batch.deleteSkippedSuffix": "，{count}個運行中未刪除",
    "batch.deletedCount": "已刪除{count}個會話{skipped}",
    "batch.deleteFailed": "批次刪除失敗",
    "batch.cancelTasksShortcut": "批次取消",
    "batch.cancelSelected": "取消任務",
    "batch.noActiveSelected": "所選任務已不在執行或等待佇列中",
    "batch.cancelTitle": "取消 {count} 個任務？",
    "batch.cancelMessage": "執行中的任務會停止，等待中的任務會離開佇列；歷史記錄都會保留。",
    "batch.cancelDetail": "執行 {running} 個 · 等待 {waiting} 個",
    "batch.cancelConfirm": "確認取消",
    "batch.cancelResult": "已取消 {cancelled} 個，略過 {skipped} 個，失敗 {failed} 個",
    "batch.cancelFailed": "批次取消失敗",
    "action.archive": "歸檔",
    "action.delete": "刪除",
    "action.cancel": "取消",
    "action.edit": "編輯",
    "action.clear": "清空",
    "action.paste": "貼上",
    "action.find": "查找",
    "action.replace": "替換",
    "action.close": "關閉",
    "action.confirm": "確認",
    "action.confirmQuestion": "確認操作？",
    "action.refresh": "↻ 重新整理",
    "action.save": "儲存",
    "action.add": "加入",
    "action.new": "新建",
    "action.import": "導入",
    "action.export": "匯出",
    "queue.empty": "暫無排隊",
    "queue.emptyAria": "佇列狀態：暫無排隊",
    "queue.jumpTitle": "跳到進行中任務",
    "queue.emptyTitle": "暫無排隊任務",
    "queue.channel": "頻道{count}",
    "queue.availableChannels": "可用通道{usable}/{total}",
    "queue.dispatching": "調度中 · 等待{waiting}",
    "queue.runningWaiting": "執行{running}· 等待{waiting}",
    "queue.statusLabel": "佇列狀態：{text}·{channelText}。點擊跳到進行中任務",
    "queue.runningActions": "執行任務佇列操作",
    "queue.waitingActions": "等待任務佇列操作",
    "queue.cancelRunning": "取消",
    "queue.cancelRunningTitle": "取消執行任務",
    "queue.dragWaiting": "拖曳調整等待順序",
    "queue.dragSort": "拖曳排序",
    "queue.moveUp": "上",
    "queue.moveUpTitle": "上移等待任務",
    "queue.moveDown": "下",
    "queue.moveDownTitle": "下移等待任務",
    "queue.promote": "頂",
    "queue.promoteTitle": "置頂等待任務",
    "queue.promoteFailed": "置頂失敗",
    "queue.deleteWaitingShort": "刪",
    "queue.deleteWaitingTitle": "刪除等待任務",
    "queue.deleteWaitingTitleConfirm": "刪除等待任務？",
    "queue.deleteWaitingMessage": "會從佇列和歷史清單中移除。",
    "queue.deleteQueuedFailed": "刪除佇列任務失敗",
    "queue.queuedDeleted": "佇列任務已刪除",
    "queue.cancelRunningConfirm": "取消任務",
    "queue.cancelRunningTitleConfirm": "取消執行任務？",
    "queue.cancelRunningMessage": "目前任務會停止，歷史記錄會保留。",
    "queue.cancelRunningFailed": "取消任務失敗",
    "queue.runningCancelled": "任務已取消",
    "queue.reorderFailed": "佇列排序失敗",
    "queue.realtimeUpdateFailed": "即時狀態更新失敗",
    "queue.realtimeDisconnected": "即時狀態連線已斷開，重新整理頁面可恢復",
    "queue.readFailed": "佇列讀取失敗",
    "status.waiting": "等待任務",
    "status.shownActiveTasks": "已顯示進行中任務",
    "status.jsonCopied": "JSON已複製",
    "taskStatus.submitting": "提交中",
    "taskStatus.running": "生成中",
    "taskStatus.runningWithElapsed": "生成中 ·{elapsed}",
    "taskStatus.completed": "已完成",
    "taskStatus.partialFailed": "部分失敗",
    "taskStatus.failed": "失敗",
    "taskStatus.queued": "排隊中",
    "taskStatus.unknown": "未知狀態",
    "taskStatus.task": "任務",
    "taskStatus.connectionInterrupted": "連線中斷",
    "taskStatus.lastFailed": "上次失敗",
    "taskStatus.waitingRetry": "{reason}，等待重試（第{attempt}/{max}次嘗試）",
    "taskStatus.retrying": "{reason}，重試中（第{attempt}/{max}次嘗試）",
    "taskStatus.nonRetryableAttempt": "第{attempt}/{max}次，不可重試",
    "taskStatus.manualRetryAvailable": "已停止，可手動重試失敗圖片",
    "taskStatus.waitingRetryShort": "等待重試",
    "taskStatus.retryingShort": "重試中",
    "taskStatus.nonRetryableShort": "不可重試",
    "taskStatus.manualRetryShort": "可手動重試",
    "taskStatus.stoppedShort": "已停止",
    "taskStatus.runtime": "耗時{duration}",
    "taskStatus.runtimeCompleted": "耗時{duration}· 完成{time}",
    "taskStatus.completedAt": "完成{time}",
    "taskCard.count": "{count}張",
    "taskCard.successCount": "成功{count}",
    "taskCard.failedCount": "失敗{count}",
    "taskCard.runningCount": "生成中{count}",
    "taskCard.waitingCount": "等待{count}",
    "taskCard.textToImageThumb": "文生圖任務縮圖",
    "taskCard.imageToImageThumb": "圖生圖任務縮圖",
    "taskCard.failedThumb": "任務失敗",
    "taskCard.textBadge": "文",
    "taskMode.edit": "編輯",
    "taskMode.generate": "生成",
    "document.generatingQueue": "生成中 · 佇列{total}",
    "document.queuedWaiting": "排隊中 · 等待{count}",
    "runFeedback.editing": "編輯中",
    "runFeedback.generating": "生成中",
    "runFeedback.status": "{action}，計時{elapsed}",
    "footer.archive": "會話歸檔",
    "footer.archiveCount": "會話歸檔{count}",
    "footer.historyLibrary": "歷史庫",
    "historyLibrary.openFull": "開啟完整歷史庫",
    "history.documentTitle": "歷史庫 - iLab CONJURE",
    "history.back": "返回生成頁",
    "history.homeAria": "返回 iLab CONJURE 生成頁",
    "history.backToGenerator": "返回生成頁",
    "history.title": "歷史庫",
    "history.loading": "載入中",
    "history.total": "{total}個任務 ·{archived}已歸檔",
    "history.search": "搜尋",
    "history.searchPlaceholder": "搜尋提示詞或任務ID",
    "history.clear": "清空",
    "history.favorites": "收藏",
    "history.onlyFavorites": "只看收藏",
    "history.favoriteTask": "收藏任務",
    "history.unfavoriteTask": "取消收藏",
    "history.tags": "標籤",
    "history.untagged": "無標籤",
    "history.manageTags": "管理標籤",
    "history.createTag": "建立標籤",
    "history.renameTag": "重新命名",
    "history.deleteTag": "刪除",
    "history.deleteTagAffected": "刪除（影響 {count} 個任務）",
    "history.addTag": "加入標籤",
    "history.removeTag": "移除標籤",
    "history.favoriteSelected": "收藏",
    "history.unfavoriteSelected": "取消收藏",
    "history.organizationFailed": "收藏或標籤更新失敗",
    "history.tagNameConflict": "這個標籤名稱已存在",
    "history.noTags": "還沒有標籤",
    "history.backendRestartRequired": "歷史庫功能已更新，請重新啟動應用程式後再試",
    "history.export": "匯出",
    "history.exportImagesOnly": "只有圖片",
    "history.exportImagesWithPrompts": "圖片＋提示詞",
    "history.exportPreparing": "正在準備匯出…",
    "history.exportStarted": "已開始下載",
    "history.exportSummary": "{taskCount} 個任務 · {imageCount} 張圖片",
    "history.exportFailed": "匯出失敗",
    "history.closeExport": "關閉匯出選擇",
    "history.type": "類型",
    "history.allTypes": "全部類型",
    "history.type.textToImage": "文生圖",
    "history.type.imageToImage": "圖生圖",
    "history.month": "月份",
    "history.status": "狀態",
    "history.promptMode": "提示詞處理",
    "history.size": "尺寸",
    "history.quality": "質量",
    "history.ratio": "比例",
    "history.orientation": "方向",
    "history.backend": "後端",
    "history.provider": "供應商",
    "history.archived": "歸檔",
    "history.all": "全部",
    "history.allMonths": "全部月份",
    "history.allStatuses": "全部狀態",
    "history.allPromptModes": "全部模式",
    "history.allSizes": "全部尺寸",
    "history.allQualities": "全部質量",
    "history.allRatios": "全部比例",
    "history.ratioOther": "其他",
    "history.allOrientations": "全部方向",
    "history.allBackends": "全部後端",
    "history.allProviders": "全部供應商",
    "history.unarchived": "未歸檔",
    "history.archivedOnly": "已歸檔",
    "history.tasksAria": "歷史任務",
    "history.taskListTitle": "歷史任務",
    "history.browseNewest": "按時間倒序瀏覽",
    "history.view": "視圖",
    "history.grid": "網格",
    "history.list": "列表",
    "history.sort": "排序",
    "history.newest": "最新優先",
    "history.oldest": "最早優先",
    "history.refresh": "重新整理",
    "history.selectedCount": "已選擇{count}個任務",
    "history.confirmDelete": "確認刪除",
    "history.detail": "任務詳情",
    "history.detailTitle": "歷史任務",
    "history.closeDetail": "關閉任務詳情",
    "history.resizeFilters": "調整篩選欄寬度",
    "history.resizeDetail": "調整詳情列寬度",
    "history.detailEmpty": "選擇一個歷史任務檢視詳情",
    "history.loadingDetail": "載入詳情...",
    "history.loadMore": "繼續載入",
    "history.loadingMore": "載入...",
    "history.noMore": "沒有更多任務",
    "history.loadFailed": "載入失敗，重新整理或繼續滾動重試",
    "history.summaryFailed": "摘要載入失敗",
    "history.tasksFailed": "歷史任務載入失敗",
    "history.detailFailed": "詳情載入失敗",
    "history.noMatches": "暫無匹配任務",
    "history.loadedCount": "{count}條已載入",
    "history.windowNotice": "清單視窗已限制為{count}條；上下滾動會按需恢復相鄰任務",
    "history.selectTask": "選擇任務",
    "history.viewing": "查看中",
    "history.noPreview": "暫無可預覽圖片",
    "history.downloadAll": "打包下載",
    "history.downloadImage": "下載圖片",
    "history.downloadSelected": "下載精選",
    "history.deleteUnselected": "刪除未精選",
    "history.confirmDeleteUnselected": "確認刪除未精選",
    "history.selected": "已精選",
    "history.select": "精選",
    "history.downloadIndex": "下載{index}",
    "history.addReference": "加入參考圖",
    "history.outputActions": "結果圖操作",
    "history.inputReferences": "輸入參考圖",
    "history.inputReferenceIndex": "輸入參考圖{index}",
    "history.copyPrompt": "複製提示詞",
    "history.copyPrompts": "複製提示詞",
    "history.copyPromptShort": "複製",
    "history.copyPromptPanel": "複製{title}",
    "history.copyOutputPromptPanel": "複製圖{index}最佳化提示詞",
    "history.copyTaskIds": "複製任務ID",
    "history.reuseTask": "生成頁查看",
    "history.downloadTask": "下載",
    "history.downloadSelectedTasks": "批次下載",
    "history.contextMenuLabel": "歷史任務右鍵選單",
    "history.promptCopied": "提示詞已複製",
    "history.promptsCopied": "已複製{count}個任務的提示詞",
    "history.taskIdsCopied": "已複製{count}個任務ID",
    "history.promptCopiedShort": "已複製",
    "history.promptCopyFailed": "複製提示詞失敗",
    "history.promptCopyFailedShort": "失敗",
    "history.noPrompt": "這個任務沒有可複製的提示詞",
    "history.noPromptShort": "無內容",
    "history.downloadStarted": "已開始下載",
    "history.batchDownloadStarted": "已開始下載{count}個任務",
    "history.noDownloadableOutputs": "沒有可下載圖片",
    "history.confirmDeleteSelected": "確認刪除已選",
    "history.openPreview": "放大預覽",
    "history.closePreview": "關閉預覽",
    "history.untitled": "Untitled",
    "history.promptCompare": "提示詞對比",
    "history.promptOriginal": "原始提示詞",
    "history.promptSubmitted": "最佳化提示詞",
    "history.promptRevised": "最佳化結果",
    "history.outputRevisedPromptTitle": "圖{index}最佳化提示詞",
    "history.outputRevisedPromptNotice": "每張圖的最佳化提示詞不同，見對應圖片下方。",
    "history.promptEmpty": "暫無內容",
    "history.promptMode.strict": "保真",
    "history.promptMode.original": "原文",
    "history.promptMode.off": "自動",
    "history.quality.high": "高",
    "history.quality.medium": "中",
    "history.quality.low": "低",
    "history.quality.auto": "自動",
    "footer.batch": "批次管理",
    "footer.storage": "儲存設定",
    "footer.apiStatus": "API狀態: 正常",
    "footer.version": "版本{version}",
    "footer.versionInfo": "版本信息",
    "footer.versionLoading": "版本...",
    "footer.updateBadge": "有新版本",
    "footer.updateAvailable": "有新版本{version}",
    "version.title": "版本與更新",
    "version.loading": "正在讀取版本狀態",
    "version.current": "目前版本",
    "version.latest": "最新版本",
    "version.source": "運作方式",
    "version.sourcePortable": "一鍵包",
    "version.sourceStandard": "標準 App",
    "version.sourceSource": "原始碼運行",
    "version.upToDate": "目前已經是最新版",
    "version.updateAvailable": "發現新版本{version}。關閉WebUI服務視窗後執行更新器即可升級。",
    "version.standardUpdateAvailable": "發現新版本 {version}。包含更新助手的 macOS 標準 App 可從選單列「檢查更新」一鍵安裝；此處保留手動下載入口。",
    "version.standardManualInstall": "macOS 標準 App 在更新助手可用時支援使用者確認後自動覆蓋；舊版 macOS App 和 Windows 標準 ZIP 仍需手動替換。",
    "version.noUpdater": "目前不是一鍵包運行，不能自動啟動更新器。",
    "version.openUpdater": "啟動更新器",
    "version.release": "查看發布頁",
    "version.updaterStarted": "更新器已啟動。請關閉目前WebUI服務視窗，再按更新器提示操作。",
    "version.updaterFailed": "啟動更新器失敗，請手動執行包內更新腳本。",
    "version.onboardingTitle": "0.5.5 新增標準應用程式包",
    "version.onboardingStatus": "你已升級到 {version}。現在可以繼續使用一鍵包，也可以改用標準應用程式包。",
    "version.onboardingBody": "這次更新新增了 macOS DMG 和 Windows App ZIP。新使用者建議使用標準包；目前的一鍵包仍可繼續使用。",
    "version.onboardingDataPortable": "目前資料已保留在這個一鍵包的 data/ 目錄。",
    "version.onboardingStandardData": "標準 App 會把資料放到系統應用程式資料目錄：macOS Application Support / Windows %APPDATA%。",
    "version.onboardingMigration": "切換標準 App 時請使用遷移助手複製舊資料，不會移動或覆蓋原資料。",
    "version.standardDownload": "下載標準版",
    "version.continuePortable": "繼續使用一鍵包",
    "version.dismissOnboarding": "不再提示",
    "version.dismissFailed": "無法保存提示狀態，請稍後再試。",
    "notifications.title": "任務通知",
    "notifications.unread": "任務通知，{count}條未讀",
    "notifications.unreadSummary": "{count}未讀",
    "notifications.empty": "暫無任務通知",
    "notifications.taskFailed": "任務失敗",
    "notifications.taskPartial": "任務部分完成",
    "notifications.taskCompleted": "任務已完成",
    "notifications.generationFailed": "生成失敗",
    "notifications.successCount": "{count}張成功",
    "notifications.resultAvailable": "有結果可查看",
    "notifications.failedCount": "{count}張失敗",
    "notifications.systemUnsupported": "目前瀏覽器不支援系統通知",
    "notifications.systemBlocked": "系統通知已被瀏覽器阻止，需要在瀏覽器設定中開啟",
    "notifications.systemDenied": "系統通知未開啟",
    "notifications.systemEnabled": "系統通知已開啟",
    "notifications.taskMissing": "任務不存在或已刪除",
    "theme.label": "主題模式",
    "theme.system": "跟隨",
    "theme.light": "淺色",
    "theme.dark": "深色",
    "language.label": "介面語言",
    "language.zh": "中",
    "language.zhCN": "簡體中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "language.vi": "Tiếng Việt",
    "auth.label": "授權來源",
    "auth.checking": "授權檢查中",
    "auth.missingCodexSession": "沒有偵測到Codex登入態",
    "auth.switchFailed": "授權來源切換失敗",
    "auth.sourceUnavailable": "{source}不可用",
    "auth.notActive": "未生效",
    "api.settings": "系統設定",
    "api.provider": "API供應商",
    "imageInput.title": "圖片輸入",
    "imageInput.uploadAria": "點選、拖曳或貼上圖片與檔案",
    "imageInput.uploadFull": "點選、拖曳或貼上圖片與檔案",
    "imageInput.uploadCompact": "新增輸入",
    "imageInput.uploadSubtitle": "支援圖片與 Responses 參考檔案",
    "imageInput.recent": "最近上傳",
    "imageInput.recentBadge": "最近",
    "imageInput.uploadBadge": "上傳",
    "imageInput.addToGallery": "加入圖庫",
    "imageInput.addToGalleryShort": "圖庫",
    "imageInput.removeImage": "移除圖片",
    "imageInput.editedBadge": "已編輯",
    "imageInput.editImage": "編輯{name}",
    "imageInput.deletedRecent": "最近上傳已刪除",
    "imageInput.deletedGallery": "圖庫圖片已刪除",
    "recentAssets.defaultName": "最近上傳",
    "recentAssets.use": "使用{name}",
    "recentAssets.delete": "刪除{name}",
    "recentAssets.deleteTitle": "刪除最近上傳？",
    "recentAssets.deleteMessage": "會從「最近上傳」刪除這張圖片。如果它已被加入到目前圖像輸入，會從目前輸入中移除；歷史任務里參照這張最近上傳圖的輸入預覽也會失效。不會影響公用圖庫。",
    "recentAssets.loadFailed": "最近上傳讀取失敗",
    "recentAssets.deleteFailed": "最近上傳刪除失敗",
    "recentAssets.deleted": "最近上傳已刪除",
    "inputSource.uploadFallback": "上傳圖片",
    "inputSource.galleryFallback": "圖庫圖片",
    "inputSource.focusPasteFallback": "{prefix}，圖片輸入區已聚焦，請按{shortcut}貼上圖片",
    "inputSource.pastedCount": "已貼上{count}張剪貼簿圖片",
    "inputSource.droppedCount": "已新增{count}張拖入圖片",
    "inputSource.dropImagesOnly": "只能拖入圖片文件",
    "inputSource.clipboardUnsupported": "目前瀏覽器不支援直接讀取剪貼簿",
    "inputSource.clipboardEmpty": "沒有讀到剪貼簿圖片",
    "inputSource.clipboardDenied": "瀏覽器拒絕直接讀取剪貼簿",
    "inputSource.clipboardReadFailed": "無法讀取剪貼簿",
    "status.missingGalleryReference": "有圖庫參考圖已刪除，請移除後再生成",
    "status.missingRecentReference": "有最近上傳參考圖已刪除，請移除後再生成",
    "status.emptyPrompt": "請輸入提示詞",
    "status.editNeedsImage": "編輯模式至少需要 1 張圖片",
    "status.loadedTask": "已載入任務{taskId}",
    "status.reusedTask": "已在生成頁面開啟任務{taskId}",
    "status.loadingHistoryInputs": "正在載入歷史輸入圖...",
    "status.historyInputLoadFailed": "無法載入歷史輸入圖:{url}",
    "referenceCollector.alreadyStaged": "已在待加入參考圖",
    "referenceCollector.staged": "已暫存{count}張參考圖",
    "referenceCollector.title": "待加入參考圖 ·{count}張",
    "referenceCollector.addAll": "全部加入參考圖",
    "referenceCollector.itemFallback": "待加入參考圖",
    "referenceCollector.remove": "移除待加入參考圖",
    "referenceCollector.cleared": "待加入參考圖已清空",
    "referenceCollector.added": "已加入{count}張參考圖",
    "referenceCollector.addFailed": "待加入參考圖加入失敗",
    "referenceCollector.readFailed": "圖片讀取失敗：{status}",
    "gallery.quick": "快速選擇公用圖庫",
    "gallery.current": "目前分類圖庫",
    "gallery.categories": "圖庫分類",
    "gallery.categoryPortrait": "人像",
    "gallery.categoryCharacter": "角色",
    "gallery.categoryProduct": "產品",
    "gallery.categoryPortraitRole": "人像參考",
    "gallery.categoryCharacterRole": "角色參考",
    "gallery.categoryProductRole": "產品參考",
    "gallery.referenceRole": "參考圖",
    "gallery.manage": "管理公用庫",
    "gallery.loadFailed": "圖庫讀取失敗",
    "gallery.imageOrderUpdateFailed": "更新圖片順序失敗",
    "gallery.imageOrderUpdated": "圖片順序已更新",
    "gallery.categoryName": "分類名稱",
    "gallery.categoryPromptRole": "提示詞用途",
    "gallery.categorySave": "儲存",
    "gallery.categoryDelete": "刪除",
    "gallery.categoryLoadFailed": "分類讀取失敗",
    "gallery.categoryNameRequired": "請輸入分類名稱",
    "gallery.categoryCreateFailed": "新增分類失敗",
    "gallery.categoryCreated": "分類已新增",
    "gallery.categorySaveFailed": "儲存分類失敗",
    "gallery.categorySaved": "分類已儲存",
    "gallery.categoryDeleteTitle": "刪除圖庫分類？",
    "gallery.categoryDeleteMessage": "分類下的圖片會移動到其他分類，圖庫圖片不會被刪除。",
    "gallery.categoryDeleteConfirm": "刪除分類",
    "gallery.categoryDeleteFailed": "刪除分類失敗",
    "gallery.categoryDeletedMigrated": "分類「{name}」已刪除，圖片已遷移",
    "gallery.categoryOrderUpdateFailed": "更新分類順序失敗",
    "gallery.categoryOrderUpdated": "分類順序已更新",
    "gallery.categoryFallback": "圖庫分類",
    "gallery.imageFallback": "圖庫圖片",
    "gallery.imageLoadFailed": "無法載入這張圖片",
    "gallery.editImageLoadFailed": "無法載入這張圖片進行編輯",
    "gallery.cannotAddImage": "這張圖片無法加入圖庫",
    "gallery.nameRequired": "請輸入圖庫名稱",
    "gallery.saveFailed": "儲存圖庫失敗",
    "gallery.savedAsReference": "已新增至圖庫，並切換為圖庫參照",
    "gallery.renameImage": "重新命名圖庫圖片",
    "gallery.moveToCategory": "移動到分類",
    "gallery.categoryRequired": "請選擇圖庫分類",
    "gallery.promptNoteTitle": "圖庫參照備註",
    "gallery.updateFailed": "更新圖庫失敗",
    "gallery.selectImageFile": "請選擇圖片文件",
    "gallery.replaceImageFailed": "替換圖庫圖片失敗",
    "gallery.replacedImage": "已取代「{name}」的原圖",
    "gallery.deleteImageTitle": "刪除圖庫圖片？",
    "gallery.deleteImageMessage": "歷史任務裡的參照會顯示為已刪除。",
    "gallery.deleteFailed": "刪除圖庫失敗",
    "gallery.deletedSuffix": "（已刪除）",
    "gallery.editImageLabel": "編輯圖庫圖片",
    "gallery.fieldCategory": "分類",
    "gallery.fieldPromptNote": "參照備註",
    "gallery.fieldName": "名稱",
    "quickGallery.empty": "暫無{category}圖片",
    "promptGallery.remove": "移除 @{name}",
    "prompt.title": "提示詞",
    "prompt.editorLabel": "提示詞",
    "prompt.placeholder": "描述你要生成或編輯的圖片，輸入 @ 可呼叫圖庫參考圖，輸入 # 可插入顏色碼，輸入 ~ 或 ～ 可呼叫提示詞片段",
    "prompt.run": "開始生成",
    "prompt.runEdit": "開始編輯",
    "prompt.runTitle": "開始產生（Cmd+Enter）",
    "prompt.runEditTitle": "開始編輯（Cmd+Enter）",
    "prompt.findPanel": "尋找替換提示詞",
    "prompt.findText": "尋找文本",
    "prompt.replaceWith": "替換為",
    "prompt.findActions": "尋找取代操作",
    "prompt.countZero": "0 處",
    "prompt.matchCount": "{count}處",
    "prompt.foundCount": "找到{count}處",
    "prompt.noMatch": "找不到符合文本",
    "prompt.replacedCount": "已取代{count}處",
    "prompt.closeFind": "關閉查找替換",
    "prompt.recentTemplates": "最近使用模板",
    "prompt.manageTemplates": "管理範本庫",
    "promptModel.galleryHeader": "參考圖說明：",
    "promptModel.galleryInstruction": "- 參考圖{number}：圖庫「{name}」，用途：{role}。提示詞中的 @{name}指這張圖。{note}",
    "outputSettings.title": "輸出設定",
    "output.lock.lock": "鎖定參數",
    "output.lock.unlock": "解鎖並修改",
    "output.lock.current": "目前鎖定",
    "output.lock.task": "所選任務參數",
    "output.lock.adoptTask": "使用此任務參數",
    "output.lock.frame": "畫幅",
    "output.lock.outputCount": "輸出張數",
    "output.lock.output": "輸出",
"output.lock.search": "搜尋",
    "output.lock.call": "呼叫",
    "output.lock.sheets": "張",
    "output.lock.imageModel": "圖像模型",
    "output.lock.prompt": "提示詞",
    "output.lock.fileFormat": "檔案格式",
    "output.lock.taskHint": "僅檢視所選任務參數；目前鎖定參數保持不變。使用後不會改變系統通道。",
    "output.lock.lockedHint": "參數已固定。點擊右上角鎖圖示恢復編輯。",
    "output.lock.enabled": "開啟",
    "output.lock.disabled": "關閉",
    "output.lock.custom": "自訂",
    "output.mainModel": "主模型",
    "output.selectMainModel": "選擇主模型",
    "output.mainModelCustomForInput": "依目前輸入使用自訂模型",
    "output.apiDirect": "API直連",
    "output.apiToolModel": "使用 API 影像生成模型",
    "output.mainModelUnused": "主模型不參與本次請求",
    "output.webSearch": "聯網搜尋",
    "output.webSearchToggle": "開啟",
    "output.webSearchTitle": "先聯網搜尋，再用於本次生成；僅Codex和APIResponses 支持",
    "output.promptMode": "提示詞處理",
    "output.modeOriginal": "原文",
    "output.modeStrict": "保真",
    "output.modeCreative": "自動",
    "output.promptHelp": "查看提示詞處理說明",
    "output.promptHelpTitle": "提示詞處理",
    "output.promptHelp.responsesChannel": "Responses · 主模型參與",
    "output.promptHelp.imagesChannel": "Images · 直接生成",
    "output.promptHelp.responses.original": "原文交給主模型，並要求圖像工具盡量逐字使用；主模型仍可能產生 revised prompt。",
    "output.promptHelp.responses.strict": "允許主模型整理或擴寫，但必須保留物件、文字、顏色、構圖等硬性限制。",
    "output.promptHelp.responses.automatic": "不加入額外限制，由主模型理解並最佳化後呼叫圖像工具。",
    "output.promptHelp.images.original": "應用程式不加入提示詞規則，按使用者原文直接提交至圖像介面。",
    "output.promptHelp.images.strict": "應用程式將保真規則與原提示詞一併提交，強調保留所有硬性限制。",
    "output.promptHelp.images.automatic": "按圖像介面的預設方式提交；圖庫引用等必要說明仍會隨提示詞傳送。",
    "output.size": "輸出尺寸",
    "output.sizeMode": "尺寸模式",
    "output.sizePreset": "預設尺寸",
    "output.sizeCustom": "自訂尺寸",
    "output.orientation": "方向",
    "output.square": "方形",
    "output.portrait": "垂直圖",
    "output.landscape": "橫圖",
    "output.resolution": "解析度",
    "output.pixelSize": "像素尺寸",
    "output.width": "寬度",
    "output.height": "高度",
    "output.swapSize": "交換寬高",
    "output.customSizeHint": "單位px· 16-3840 · 16倍數 · ≤3:1",
    "output.imageSizeUnavailable": "圖片尺寸不可用",
    "output.imageLoadFailed": "圖片載入失敗",
    "output.customSizeRequired": "請輸入寬度和高度",
    "output.customSizeBounds": "寬高需在 16-3840px之間",
    "output.customSizeMultiple": "寬高需為 16 的倍數",
    "output.customSizeRatio": "長短邊比例不能超過 3:1",
    "output.customSizePixels": "總像素需在 655,360-8,294,400 之間",
    "output.ratioLock": "比例鎖定（可選）",
    "output.customRatio": "自訂寬高比",
    "output.ratioWidth": "寬",
    "output.ratioHeight": "高",
    "output.firstImageRatio": "取得第一張參考圖寬高比",
    "output.useFirstImage": "取首圖",
    "output.ratioHint": "留空則自由寬高 · 填滿後同步",
    "output.ratio": "比例",
    "output.quality": "質量",
    "output.qualityAuto": "自動",
    "output.qualityLow": "低",
    "output.qualityMedium": "中",
    "output.qualityHigh": "高",
    "output.quantity": "數量",
    "output.pixelPreview": "輸出像素: 1024 x 1024px",
    "output.pixelPreviewValue": "輸出像素:{value}",
    "output.pixelPreviewAuto": "輸出像素: auto（OpenAI 自動選擇）",
    "output.format": "輸出格式",
    "output.compression": "壓縮率",
    "output.moderation": "審核",
    "preview.title": "預覽",
    "preview.selectedZero": "已選 0",
    "preview.selectedCount": "已選{selected}/{total}",
    "preview.downloadSelected": "只下載精選",
    "preview.deleteUnselected": "刪除未精選",
    "preview.downloadAll": "打包下載",
    "preview.empty": "暫無圖片",
    "preview.taskFailed": "任務失敗",
    "preview.partialFailed": "部分圖片產生失敗",
    "preview.failedOutput": "第{index}張失敗",
    "preview.progressLine": "已完成{generated}/{total}· 計時{elapsed}",
    "preview.failureLine": "已完成{generated}/{total}· 失敗{failed}",
    "preview.elapsedLine": "計時{elapsed}",
    "preview.lastError": "上次錯誤：{error}",
    "preview.continueGenerating": "繼續生成中",
    "preview.waitingContinue": "等待繼續生成",
    "preview.retryFailed": "僅重試失敗圖片",
    "preview.acceptSuccesses": "接受已成功結果",
    "preview.generateMode": "生成",
    "preview.editMode": "編輯",
    "preview.runningTitle": "{mode}任務運行中",
    "preview.submittingTitle": "提交任務中",
    "preview.queuedTitle": "任務排隊中",
    "preview.submittingDetail": "正在儲存輸入並寫入佇列，完成後會自動進入產生流程。",
    "preview.queuedDetail": "任務已進入佇列，等待可用通道接手。",
    "preview.featured": "精選",
    "preview.addFeatured": "加入精選",
    "preview.selectedFeatured": "已精選",
    "preview.removeFeatured": "取消精選",
    "preview.selectionAdded": "已加入精選",
    "preview.selectionRemoved": "已取消精選",
    "preview.selectionUpdateFailed": "精選狀態更新失敗",
    "preview.noUnselectedOutputs": "沒有可刪除的未精選圖片",
    "preview.deleteUnselectedTitle": "刪除未精選圖片？",
    "preview.deleteUnselectedMessage": "會刪除目前任務中未精選的本機圖片檔案。",
    "preview.deleteUnselectedDetail": "保留{selected}張，刪除{deleted}張",
    "preview.deleteUnselectedFailed": "刪除未精選失敗",
    "preview.deleteUnselectedDone": "未精選圖片已刪除",
    "preview.addReference": "加入參考圖",
    "preview.stage": "暫存",
    "preview.stageReference": "暫存到待加入參考圖",
    "preview.prompt": "提示詞",
    "preview.download": "下載",
    "preview.downloadImage": "下載該圖片",
    "lightbox.label": "圖片預覽",
    "lightbox.close": "關閉預覽",
    "lightbox.previous": "上一張",
    "lightbox.next": "下一張",
    "promptPopover.title": "提示詞對比",
    "promptPopover.summary": "原始{original}· 最佳化{optimized}",
    "promptPopover.original": "原始提示詞",
    "promptPopover.optimized": "優化後提示詞",
    "promptPopover.charCount": "{count}字",
    "promptPopover.empty": "無",
    "promptPopover.notReturned": "未回傳",
    "promptPopover.noOptimized": "未回傳最佳化提示詞",
    "promptPopover.submitted": "查看實際提交提示詞",
    "promptPopover.close": "關閉提示詞",
    "promptPopover.copyOptimized": "複製優化後提示詞",
    "promptPopover.copied": "已複製",
    "taskContext.menuLabel": "任務右鍵選單",
    "taskContext.view": "查看任務",
    "taskContext.copyId": "複製任務ID",
    "taskContext.copyPrompt": "複製提示詞",
    "taskContext.revealOutput": "開啟輸出目錄",
    "taskContext.archive": "歸檔任務",
    "taskContext.delete": "刪除任務",
    "taskContext.idCopied": "任務ID已複製",
    "taskContext.promptCopied": "提示詞已複製",
    "taskContext.noPrompt": "這個任務沒有可複製的提示詞",
    "taskContext.revealFailed": "開啟輸出目錄失敗",
    "taskContext.revealOpened": "已開啟輸出目錄",
    "taskContext.actionFailed": "任務操作失敗",
    "taskActions.group": "任務操作",
    "taskActions.deleteTitle": "刪除任務？",
    "taskActions.deleteMessage": "會同時刪除本機圖片檔案。",
    "taskActions.runningCannotDelete": "執行中的任務不能刪除",
    "taskActions.updated": "任務狀態已更新",
    "taskActions.archived": "會話已歸檔",
    "taskActions.archiveFailed": "歸檔失敗",
    "taskActions.deleted": "任務已刪除",
    "taskActions.deleteFailed": "刪除失敗",
    "taskActions.noRetryableFailedImages": "這個任務沒有可重試的失敗圖片",
    "taskActions.retryFailedOutputsFailed": "重試失敗圖片失敗",
    "taskActions.requeuedFailedImages": "已重新入隊失敗圖片",
    "taskActions.noAcceptableSuccessImages": "這個任務沒有可接受的成功圖片",
    "taskActions.acceptSuccessesFailed": "接受成功結果失敗",
    "taskActions.acceptedSuccesses": "已接受成功結果",
    "taskActions.viewedUpdateFailed": "已讀狀態更新失敗",
    "taskActions.failedFallback": "任務失敗",
    "taskList.empty": "暫無歷史任務",
    "taskList.selectSession": "選擇會話",
    "taskList.unreadUpdate": "未讀更新",
    "taskList.viewing": "查看中",
    "taskList.backToLatest": "回到最新任務",
    "taskList.backToLatestWithCount": "回到最新任務，上方有 {count} 個新任務",
    "taskDerived.usageLimited": "用量受限",
    "taskSubmit.requestFailed": "請求失敗",
    "taskSubmit.queued": "任務已加入佇列",
    "taskSubmit.timeout": "提交任務逾時，後端沒有及時回傳。請重新整理隊列後確認是否已入隊，再決定是否重試。",
    "taskSubmit.failed": "任務提交失敗",
    "templates.title": "提示詞模板",
    "templates.summary": "本機範本庫",
    "templates.availableCount": "{count}個可用模板",
    "templates.noMatch": "暫無匹配模板",
    "templates.empty": "暫無模板",
    "templates.favoriteBadge": "已收藏",
    "templates.usageCount": "{count}次",
    "templates.back": "返回",
    "templates.edit": "編輯",
    "templates.copy": "複製",
    "templates.insert": "插入",
    "templates.formTitle": "標題",
    "templates.formShortTitle": "短標題",
    "templates.formCategory": "分類",
    "templates.formTags": "標籤",
    "templates.formThumbnail": "縮圖",
    "templates.formContent": "內容",
    "templates.formNotes": "備註",
    "templates.formFavorite": "收藏",
    "templates.thumbnailClear": "清除",
    "templates.thumbnailNone": "未選擇",
    "templates.thumbnailEmpty": "暫無歷史縮圖",
    "templates.newCategory": "新分類",
    "templates.search": "搜尋範本、標籤、內容",
    "templates.filter": "範本篩選",
    "templates.all": "全部",
    "templates.categoryCommon": "常用",
    "templates.categoryPortrait": "人像",
    "templates.categoryProduct": "產品",
    "templates.categoryRepair": "修復",
    "templates.categoryPoster": "海報",
    "templates.categoryEcommerce": "電商",
    "templates.favorite": "收藏",
    "templates.recent": "最近",
    "templates.category": "分類",
    "templates.loadFailed": "提示詞範本讀取失敗",
    "templates.useStateUpdateFailed": "提示字範本使用狀態更新失敗",
    "templates.copied": "提示詞範本已複製",
    "templates.copyFailed": "提示字範本複製失敗",
    "templates.history": "歷史記錄",
    "templates.saveFailed": "提示詞範本儲存失敗",
    "templates.saved": "提示詞範本已儲存",
    "templates.deleteFailed": "提示字範本刪除失敗",
    "templates.deleted": "提示詞範本已刪除",
    "templates.categoryAddFailed": "範本分類新增失敗",
    "templates.categoryAdded": "模板分類已加入",
    "templates.categorySaveFailed": "範本分類儲存失敗",
    "templates.categorySaved": "範本分類已儲存",
    "templates.categoryDeleteFailed": "範本分類刪除失敗",
    "templates.categoryDeleted": "範本分類已刪除",
    "templates.importFailed": "範本包導入失敗",
    "templates.importedCount": "已匯入{count}個模板",
    "templates.exportFailed": "範本包匯出失敗",
    "templates.exported": "模板包已匯出",
    "snippets.suggestLabel": "提示詞片段選擇器",
    "snippets.saveSelection": "收藏",
    "snippets.saveSelectionLabel": "收藏選取的提示詞片段",
    "snippets.popoverLabel": "提示詞片段",
    "snippets.defaultCategory": "常用",
    "snippets.loadFailed": "提示詞片段讀取失敗",
    "snippets.remove": "移除 ~{tag}",
    "snippets.expand": "展開",
    "snippets.edit": "編輯",
    "snippets.close": "關閉",
    "snippets.editTitle": "編輯片段",
    "snippets.saveTitle": "收藏片段",
    "snippets.shortTag": "短標籤",
    "snippets.title": "標題",
    "snippets.category": "分類",
    "snippets.content": "內容",
    "snippets.titlePlaceholder": "預設使用短標籤",
    "snippets.cancel": "取消",
    "snippets.save": "儲存",
    "snippets.saveFailed": "提示詞片段儲存失敗",
    "snippets.saved": "提示詞片段已儲存",
    "snippets.defaultTag": "常用片段",
    "colors.white": "白色",
    "colors.black": "黑色",
    "colors.warmBeige": "暖米色",
    "colors.lightGreen": "淺綠",
    "colors.brandGreen": "品牌綠",
    "colors.peachOrange": "桃橙",
    "colors.lightBlue": "淺藍",
    "colors.lightPink": "淺粉",
    "colors.loadFailed": "顏色配置讀取失敗",
    "colors.saveFailed": "顏色配置儲存失敗",
    "colors.importFailed": "顏色配置導入失敗",
    "colors.importedCount": "已匯入{count}個顏色",
    "colors.recentSaveFailed": "最近顏色儲存失敗",
    "colors.favoriteSaveFailed": "常用顏色儲存失敗",
    "colors.favoriteDeleteFailed": "常用顏色刪除失敗",
    "colors.update": "更新",
    "colors.insert": "插入",
    "colors.pick": "選擇顏色",
    "colors.pickShort": "取色",
    "colors.hexValue": "顏色值",
    "colors.pendingUpdate": "顏色已修改，點選更新生效",
    "colors.save": "儲存",
    "colors.exportPs": "匯出",
    "colors.importPs": "導入",
    "colors.done": "完成",
    "colors.manage": "管理",
    "colors.favorites": "常用顏色",
    "colors.recent": "最近顏色",
    "colors.recentLabel": "最近",
    "colors.deleteFavorite": "刪除常用色{name}",
    "colors.modify": "修改顏色",
    "colors.modifyValue": "修改顏色{value}",
    "colors.removeValue": "移除顏色{value}",
    "taskGroup.today": "今天",
    "taskGroup.yesterday": "昨天",
    "taskGroup.last7": "最近 7 天",
    "taskGroup.older": "更早",
    "taskGroup.searchResults": "搜尋結果",
    "taskGroup.active": "活動任務",
    "taskGroup.running": "運作中",
    "taskGroup.waiting": "等待中",
    "taskGroup.dispatchPending": "正在分配可用通道...",
    "taskGroup.expand": "展開{label}",
    "taskGroup.collapse": "收起{label}",
    "taskGroup.buttonLabel": "{label}，{count}個任務",
    "taskGroup.loadMore": "再載入{count}筆",
    "archive.title": "會話歸檔",
    "archive.empty": "暫無歸檔會話",
    "archive.count": "{count}個歸檔會話",
    "archive.restore": "恢復",
    "archive.archiveFailed": "歸檔失敗",
    "archive.restoreFailed": "恢復失敗",
    "archive.restored": "會話已恢復",
    "archive.archiving": "正在歸檔...",
    "archive.restoring": "正在恢復...",
    "archive.deleting": "正在刪除...",
    "archive.restoredCount": "已恢復{count}個任務",
    "settings.title": "儲存設定",
    "settings.status": "儲存路徑設定後重啟 WebUI 生效",
    "settings.inputRoot": "輸入目錄",
    "settings.outputRoot": "輸出目錄",
    "settings.galleryRoot": "公用圖庫目錄",
    "settings.sourceDataRoot": "來源資料目錄",
    "settings.language": "介面語言",
    "settings.languageCopy": "首次啟動會自動跟隨瀏覽器語言，手動選擇後會記住偏好。",
    "settings.notificationsCopy": "任務完成或失敗時提醒，系統通知需手動開啟。",
    "settings.inAppNotification": "站內通知",
    "settings.systemNotification": "系統通知",
    "settings.save": "儲存設定",
    "settings.loadFailed": "設定讀取失敗",
    "settings.saveFailed": "設定儲存失敗",
    "settings.savedRestart": "儲存設定已儲存，重啟 WebUI 後生效",
    "settings.saved": "已儲存",
    "settings.savedRestartStatus": "儲存設定已儲存，重啟 WebUI 後生效",
    "systemSettings.title": "系統設定",
    "systemSettings.tabsLabel": "系統設定選項",
    "systemSettings.apiTab": "API 設定",
    "systemSettings.codexTab": "Codex 通道",
    "systemSettings.languageTab": "語言 / Language",
    "systemSettings.storageTab": "儲存與通知",
    "systemSettings.networkTab": "網路",
    "networkEgress.mode": "網路出口",
    "networkEgress.system": "系統",
    "networkEgress.direct": "直連",
    "networkEgress.custom": "自訂",
    "networkEgress.customProxy": "自訂代理位址",
    "networkEgress.currentRoute": "目前出口：{route}",
    "networkEgress.test": "測試連線",
    "networkEgress.save": "儲存並套用",
    "networkEgress.saved": "網路出口已儲存",
    "networkEgress.testSucceeded": "連線成功：{target}（{elapsed} 毫秒）",
    "networkEgress.testFailed": "連線測試失敗",
    "networkEgress.loadFailed": "無法載入網路設定",
    "networkEgress.saveFailed": "無法儲存網路設定",
    "languageSettings.instantStatus": "語言切換後立即生效",
    "apiSettings.title": "API設定",
    "apiSettings.status": "儲存後立即用於API模式",
    "apiSettings.codexMode": "Codex頻道",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API供應商",
    "apiSettings.searchProviders": "搜尋供應商名稱",
    "apiSettings.noProviderSearchResults": "找不到相符的供應商",
    "apiSettings.providerCount": "{count}個供應商",
    "apiSettings.provider": "供應商",
    "apiSettings.providerName": "供應商名稱",
    "apiSettings.providerIcon": "Emoji 圖示",
    "apiSettings.providerIconPlaceholder": "選填，例如 🪄",
    "apiSettings.connectionScope": "连接级设置",
    "apiSettings.connectionPreview": "連線預覽",
    "apiSettings.modelBindings": "模型绑定",
    "apiSettings.modelBindingsHint": "一个供应商可同时绑定多个型号和协议。",
    "apiSettings.addModelBinding": "添加模型绑定",
    "apiSettings.appendRatioPrompt": "追加比例提示",
    "apiSettings.defaultProviderForModel": "設為預設供應商",
    "apiSettings.removeBinding": "刪除綁定",
    "apiSettings.catalogRequiredForBinding": "模型目录不可用，暂时无法添加绑定",
    "apiSettings.keepOneBinding": "每个供应商至少保留一条模型绑定",
    "apiSettings.bindingRequiredFields": "请为每条绑定选择型号、填写远端模型名并至少选择一个操作",
    "apiSettings.bindingOverlap": "{model} 的 {operation} 操作被多条绑定重复处理",
    "apiSettings.actualRequest": "實際請求",
    "apiSettings.newProviderAction": "新建供應商",
    "apiSettings.copyProvider": "複製",
    "apiSettings.copyProviderName": "{name}副本",
    "apiSettings.copyProviderStatus": "已複製配置和已儲存 Key，可修改名稱、模型或替換 Key 後儲存",
    "apiSettings.copyProviderWithoutKeyStatus": "已複製配置，可修改名稱、模型或填寫API Key後儲存",
    "apiSettings.sortProviders": "排序",
    "apiSettings.finishSortProviders": "完成",
    "apiSettings.sortProviderModeStatus": "正在排序供應商",
    "apiSettings.sortProviderStatus": "供應商排序已調整，正在自動儲存",
    "apiSettings.moveProviderUp": "上移",
    "apiSettings.moveProviderDown": "下移",
    "apiSettings.moveProviderUpAria": "上移{provider}",
    "apiSettings.moveProviderDownAria": "下移{provider}",
    "apiSettings.mode": "呼叫方式",
    "apiSettings.images": "直連Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "直連",
    "apiSettings.imageModel": "影像生成模型",
    "apiSettings.concurrency": "並發上限",
    "apiSettings.concurrencyShort": "並發",
    "apiSettings.advancedSettings": "進階設定",
    "apiSettings.concurrencyValue": "併發{concurrency}",
    "apiSettings.keySaved": "已儲存API Key",
    "apiSettings.keyNotSet": "未設定API Key",
    "apiSettings.showApiKey": "顯示 API Key",
    "apiSettings.hideApiKey": "隱藏 API Key",
    "apiSettings.editProvider": "編輯供應商",
    "apiSettings.newProviderTitle": "新增供應商",
    "apiSettings.editHint": "點選儲存供應商後寫入後端，取消可放棄本次編輯。",
    "apiSettings.finishEditFirst": "請先儲存或取消目前供應商編輯",
    "apiSettings.newDraftStatus": "正在新增供應商，儲存供應商後生效",
    "apiSettings.editDraftStatus": "正在編輯供應商，儲存供應商後生效",
    "apiSettings.cancelEdit": "取消編輯",
    "apiSettings.saveProvider": "儲存供應商",
    "apiSettings.saveSelection": "儲存目前選擇",
    "apiSettings.deleteProviderTitle": "刪除供應商？",
    "apiSettings.deleteProviderMessage": "確定刪除「{provider}」？",
    "apiSettings.deleteProviderDetail": "會從目前供應商清單移除，並自動儲存到後端。",
    "apiSettings.deleteProviderStatus": "已刪除供應商，正在自動儲存",
    "apiSettings.save": "儲存API設定",
    "apiSettings.loadFailed": "API設定讀取失敗",
    "apiSettings.savedKeyPlaceholder": "後端已儲存API Key，輸入新 key 可覆蓋",
    "apiSettings.newProvider": "新供應商",
    "apiSettings.saving": "儲存中...",
    "apiSettings.savingStatus": "正在儲存API設定...",
    "apiSettings.autoSaving": "正在自動儲存...",
    "apiSettings.autoSaved": "已自動儲存",
    "apiSettings.saveFailed": "API設定儲存失敗",
    "apiSettings.savedSummary": "已儲存 ·Codex{codex}·API{provider}·{mode}·{model}· 並發{concurrency}",
    "apiSettings.savedShort": "已儲存",
    "apiSettings.savedStatus": "API設定已儲存",
    "apiSettings.saveFailedShort": "儲存失敗",
    "codexSettings.title": "Codex頻道",
    "codexSettings.status": "選擇Codex本機登入態使用的產生通道",
    "codexSettings.notesLabel": "Codex頻道說明",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "預設頻道，尺寸、品質和編輯參數直傳，適合一般產生和編輯。",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "相容頻道，用於需要連網搜尋或 Responses 工具鏈的任務。",
    "codexSettings.current": "目前使用",
    "codexSettings.save": "儲存Codex頻道",
    "codexSettings.saveMode": "儲存 {mode}",
    "imageEditor.title": "編輯輸入圖片",
    "imageEditor.promptHint": "圖中的手繪箭頭和標記僅用於指示編輯要求，不要保留在最終畫面中。",
    "imageEditor.inputFallback": "輸入圖片",
    "imageEditor.openFailed": "無法開啟這張圖片進行編輯",
    "imageEditor.loadForEditFailed": "無法載入這張圖片進行編輯",
    "imageEditor.canvasCreateFailed": "無法建立圖片編輯畫布",
    "imageEditor.closedRegionRequired": "請先用畫筆圈出封閉區域",
    "imageEditor.saveFailed": "圖片編輯儲存失敗",
    "imageEditor.saved": "已儲存編輯後的輸入圖",
    "imageEditor.uneditable": "這張圖片無法編輯",
    "imageEditor.resetDone": "已重設至原圖",
    "imageEditor.resetFailed": "無法重置原圖",
    "imageEditor.subtitle": "裁剪、塗鴉、油漆桶填充或加入箭頭後儲存為新的輸入圖",
    "imageEditor.toolbar": "圖片編輯工具列",
    "imageEditor.tools": "工具",
    "imageEditor.select": "選擇",
    "imageEditor.brush": "畫筆",
    "imageEditor.arrow": "箭頭",
    "imageEditor.crop": "裁剪",
    "imageEditor.fill": "油漆桶",
    "imageEditor.fillLabel": "油漆桶填充",
    "imageEditor.eraser": "擦除",
    "imageEditor.colors": "顏色",
    "imageEditor.red": "紅色",
    "imageEditor.blue": "藍色",
    "imageEditor.green": "綠色",
    "imageEditor.yellow": "黃色",
    "imageEditor.white": "白色",
    "imageEditor.black": "黑色",
    "imageEditor.customColor": "自訂顏色",
    "imageEditor.stroke": "粗細",
    "imageEditor.history": "歷史",
    "imageEditor.undo": "撤銷",
    "imageEditor.redo": "重做",
    "imageEditor.reset": "重置原圖",
    "imageEditor.canvas": "圖片編輯畫布",
    "imageEditor.canvasScope": "畫布範圍",
    "imageEditor.canvasScopeBase": "首圖",
    "imageEditor.canvasScopeFit": "適應圖層",
    "imageEditor.canvasFitDone": "畫布已適應圖層範圍",
    "imageEditor.canvasBaseDone": "畫布已恢復首圖範圍",
    "imageEditor.insertImages": "插入圖片",
    "imageEditor.layers": "圖層",
    "imageEditor.layerUp": "上移",
    "imageEditor.layerDown": "下移",
    "imageEditor.emptyInsertList": "暫無其他輸入圖",
    "imageEditor.selectLayerFirst": "請先選擇圖層",
    "imageEditor.baseLayer": "原圖",
    "gallery.title": "公用圖庫",
    "gallery.subtitle": "選擇參考圖加入目前任務",
    "gallery.manageCategories": "管理分類",
    "gallery.categoryManager": "管理圖庫分類",
    "gallery.categoryManagement": "分類管理",
    "gallery.categoryCopy": "分類會儲存到圖庫；提示詞用途用於產生參考圖說明",
    "gallery.newCategoryName": "新分類名稱",
    "gallery.newCategoryRole": "提示詞用途，例如：風格參考",
    "gallery.addCategory": "新增分類",
    "gallery.drawerSubtitle": "目前分類：{category}，點選「使用」加入影像輸入",
    "gallery.emptyCategory": "這個分類還沒有圖片",
    "gallery.dragSort": "拖曳排序",
    "gallery.dragSortImage": "拖曳排序圖片{name}",
    "gallery.dragSortCategory": "拖曳排序分類{name}",
    "gallery.use": "使用",
    "gallery.replace": "替換",
    "gallery.rename": "重新命名",
    "gallery.moveCategory": "分類",
    "gallery.note": "備註",
    "gallery.delete": "刪除",
    "gallery.uncategorized": "未分類",
    "addGallery.title": "加入圖庫",
    "addGallery.copy": "名稱全域唯一，後續可用 @名稱 調取",
    "addGallery.name": "名稱",
    "addGallery.namePlaceholder": "例如：小美",
    "addGallery.category": "分類",
    "addGallery.note": "參照備註",
    "addGallery.notePlaceholder": "例如：只參考臉型和髮型，不參考衣服和背景",
    "addGallery.save": "儲存到圖庫",
    "close.promptTemplates": "關閉提示字範本面板",
    "close.archive": "關閉會話歸檔面板",
    "close.settings": "關閉儲存設定面板",
    "close.apiSettings": "關閉API設定面板",
    "close.systemSettings": "關閉系統設定面板",
    "close.imageEditor": "關閉編輯輸入圖片面板",
    "close.gallery": "關閉公用圖庫面板",
    "close.addGallery": "關閉已新增至圖庫面板",
    "close.version": "關閉版本更新面板",
    "imageInput.referenceTitle": "參考輸入（可選）",
    "referenceFiles.add": "新增檔案",
    "referenceFiles.selected": "參考檔案",
    "referenceFiles.recent": "最近檔案",
    "referenceFiles.familyPdf": "頁面 + 文字",
    "referenceFiles.familySpreadsheet": "試算表",
    "referenceFiles.familyDocument": "文件",
    "referenceFiles.familyText": "文字",
    "referenceFiles.visualLimit": "非 PDF 檔案不會保留內嵌圖片和圖表；需要版面參考時請先轉為 PDF。",
    "referenceFiles.remove": "移除檔案 {filename}",
    "referenceFiles.switchTitle": "移除參考檔案？",
    "referenceFiles.switchMessage": "參考檔案僅支援 Responses，切換到 Images 前需要移除已選檔案。",
    "referenceFiles.removeAndSwitch": "移除檔案並切換",
    "referenceFiles.requiresResponses": "參考檔案僅支援 Responses",
    "referenceFiles.switchToResponses": "切換到 Responses",
    "referenceFiles.openApiSettings": "開啟 API 設定",
    "referenceFiles.providerMissing": "原任務使用的 Responses 供應商無法使用，請在 API 設定中選擇。",
    "referenceFiles.missing": "檔案已遺失",
    "referenceFiles.loadFailed": "參考檔案載入失敗",
    "referenceFiles.errorEmpty": "參考檔案是空的",
    "referenceFiles.errorUnsupported": "不支援此參考檔案格式",
    "referenceFiles.errorMismatch": "檔案內容與副檔名不符",
    "referenceFiles.errorInvalid": "參考檔案無效",
    "referenceFiles.errorTooLarge": "單一參考檔案必須小於 50 MB",
    "referenceFiles.errorTotalTooLarge": "參考檔案總大小不得超過 50 MB",
    "referenceFiles.errorMissing": "選取的參考檔案已遺失",
    "referenceFiles.errorProviderUnsupported": "目前供應商的 Responses 不支援參考檔案",
    "referenceFiles.responsesEnabled": "已切換到 Responses",
    "referenceFiles.historyPathMismatch": "這些參考檔案使用不同的 Responses 路徑",
    "history.referenceFiles": "參考檔案",
    "history.downloadReferenceFile": "下載檔案",
    "history.readdReferenceFile": "重新加入",
    "modelSelection.family": "模型系列",
    "modelSelection.concreteModel": "具體型號",
    "modelSelection.provider": "供應商",
    "modelSelection.providerUnavailable": "目前型號沒有可用供應商",
    "modelSelection.openSettings": "開啟供應商設定",
    "modelSelection.codexUnavailable": "Codex 登入不可用",
    "modelSelection.catalogUnavailable": "模型目錄不可用",
    "output.background": "背景",
    "canvas.aspectRatio": "畫面比例",
    "canvas.resolution": "解析度",
    "gemini.googleSearch": "Google 搜尋",
    "gemini.googleImageSearch": "Google 圖片搜尋",
    "output.modalities": "輸出模態",
    "gemini.safetySettings": "安全設定",
    "gemini.safety.harassment": "騷擾",
    "gemini.safety.hateSpeech": "仇恨言論",
    "gemini.safety.sexuallyExplicit": "色情露骨內容",
    "gemini.safety.dangerousContent": "危險內容",
    "gemini.safety.threshold.unspecified": "預設",
    "gemini.safety.threshold.off": "關閉過濾",
    "gemini.safety.threshold.blockNone": "不封鎖",
    "gemini.safety.threshold.blockOnlyHigh": "封鎖高風險",
    "gemini.safety.threshold.blockMediumAndAbove": "封鎖中高風險",
    "gemini.safety.threshold.blockLowAndAbove": "封鎖全部",
    "grounding.title": "Google 搜尋來源",
    "grounding.searchSuggestions": "Google 搜尋建議",
    "grounding.sourceCount": "{count} 個來源",
    "grounding.source": "來源 {index}",
    "modelParameters.invalidValue": "參數值無效",
    "modelParameters.objectRequired": "請輸入 JSON 物件",
    "modelParameters.invalidJson": "JSON 格式無效",
    "modelParameters.migrated": "已依目前模型相容處理 {count} 個舊參數",
    "modelParameters.historyConfiguration": "歷史設定",
    "modelParameters.legacyTask": "舊版任務",
};
